<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pjbXuq/tc-custom/9780830887248.jpg?1696024903552" alt="This image is the cover for the book Mariner, Studies in Theology and the Arts Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mariner, Studies in Theology and the Arts Series
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong> <em>Instead of the cross, the Albatross<br/> About my neck was hung.</em> </strong> </p> <p>Samuel Taylor Coleridge's famous poem "The Rime of the Ancient Mariner" is often regarded as having heralded the beginning of the Romantic era in British literature. The poem narrates the story of a sailor who has returned home from a long voyage having suffered great loss, yet survived.</p> <p>In this Studies in Theology and the Arts volume, poet and theologian Malcolm Guite leads readers on a journey with Coleridge, whose own life paralleled the experience of the mariner. On this theological voyage, Guite draws out the continuing relevance of this work and the ability of poetry to communicate the truths of humanity's fallenness, our need for grace, and the possibility of redemption.</p> <p>The Studies in Theology and the Arts  series encourages Christians to thoughtfully engage with the relationship between their faith and artistic expression, with contributions from both theologians and artists on a range of artistic media including visual art, music, poetry, literature, film, and more.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Malcolm Guite
      </h2>
      
      <p class="authorDescription body article"><p>Malcolm Guite (PhD, Durham) is the chaplain at Girton College, Cambridge, where he also teaches in the Faculty of Divinity. He is a priest, a poet, and a songwriter, and he travels and speaks regularly throughout the UK and North America. He is the author of <em>Faith, Hope and Poetry: Theology and the Poetic Imagination</em> as well as several collections of poems, including <em>Parable and Paradox: Sonnets on the Sayings of Jesus and Other Poems</em>; <em>Waiting on the Word: A Poem a Day for Advent, Christmas, and Epiphany</em>; <em>The Word in the Wilderness: A Poem a Day for Lent, Holy Week, and Easter</em>, and <em>Sounding the Seasons</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3db8940a